import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = {
    dragHandle: String,
    url: String,
    scope: String
  }

  connect() {
    const url = this.urlValue;
    const elementScope = this.scopeValue;

    const options = {
      animation: 150,
      onStart: (evt) => {
        this.dispatch("start", { detail: { item: evt.item, scope: elementScope } });
      },
      onEnd: async (evt) => {
        const itemEl = evt.item;
        const elementId = itemEl.getAttribute("data-element-id");
        const parsedUrl = url.replace("ELEMENT_ID", elementId);
        const newPosition = evt.newIndex + 1;

        await patch(parsedUrl, {
          body: JSON.stringify({ [elementScope]: { position: newPosition } }),
        });

        this.dispatch("end", {
          detail: {
            item: evt.item,
            scope: elementScope,
            elementId,
            newIndex: evt.newIndex,
          },
        });
      },
    };

    options.filter = "[data-sortable-ignore],button,input,textarea,label";
    options.preventOnFilter = false;

    const explicitHandle = this.hasDragHandleValue ? this.dragHandleValue.trim() : "";
    const fallbackHandle = explicitHandle === "" ? this.fallbackHandle() : null;

    if (explicitHandle !== "") {
      options.handle = explicitHandle;
    } else if (fallbackHandle) {
      options.handle = fallbackHandle;
    }

    this.sortable = Sortable.create(this.element, options);
  }

  fallbackHandle() {
    if (!this.element.closest(".curriculum-mobile")) return null;

    if (this.element.classList.contains("section__wrapper")) {
      return ".section__card-dots--handler";
    }

    if (this.element.classList.contains("sections-aside__lection-wrapper")) {
      return ".lection-aside__item-dots";
    }

    return null;
  }
}
